import React from 'react';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export default function AnalogClock({ time, settings, dark, palette }) {
  const accent = palette?.[0] || '#3b82f6';
  const h = time.getHours() % 12;
  const m = time.getMinutes();
  const s = time.getSeconds();
  const ms = time.getMilliseconds();
  const secAngle = (s + ms / 1000) * 6;
  const minAngle = (m + s / 60) * 6;
  const hourAngle = (h + m / 60) * 30;

  const stroke = dark ? 'rgba(255,255,255,0.75)' : 'rgba(31,41,55,0.85)';
  const faint = dark ? 'rgba(255,255,255,0.15)' : 'rgba(31,41,55,0.2)';

  return (
    <div className="flex flex-col items-center">
      <svg viewBox="-110 -110 220 220" className="w-64 h-64 md:w-80 md:h-80">
        {/* Outer ring */}
        <circle cx="0" cy="0" r="100" fill="none" stroke={faint} strokeWidth="1.5" />
        {/* Hour markers */}
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i * 30) * Math.PI / 180;
          const x1 = Math.sin(a) * 92;
          const y1 = -Math.cos(a) * 92;
          const x2 = Math.sin(a) * 100;
          const y2 = -Math.cos(a) * 100;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={stroke} strokeWidth={i % 3 === 0 ? 2.5 : 1.5} strokeLinecap="round" />;
        })}
        {/* Minute markers */}
        {Array.from({ length: 60 }).map((_, i) => {
          if (i % 5 === 0) return null;
          const a = (i * 6) * Math.PI / 180;
          const x1 = Math.sin(a) * 96;
          const y1 = -Math.cos(a) * 96;
          const x2 = Math.sin(a) * 100;
          const y2 = -Math.cos(a) * 100;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={faint} strokeWidth="1" />;
        })}
        {/* Hour hand */}
        <line x1="0" y1="0"
          x2={Math.sin(hourAngle * Math.PI / 180) * 50}
          y2={-Math.cos(hourAngle * Math.PI / 180) * 50}
          stroke={stroke} strokeWidth="5" strokeLinecap="round" />
        {/* Minute hand */}
        <line x1="0" y1="0"
          x2={Math.sin(minAngle * Math.PI / 180) * 78}
          y2={-Math.cos(minAngle * Math.PI / 180) * 78}
          stroke={stroke} strokeWidth="3" strokeLinecap="round" />
        {/* Second hand */}
        {settings.showSeconds && (
          <line x1="0" y1="0"
            x2={Math.sin(secAngle * Math.PI / 180) * 86}
            y2={-Math.cos(secAngle * Math.PI / 180) * 86}
            stroke={accent} strokeWidth="1.5" strokeLinecap="round" />
        )}
        <circle cx="0" cy="0" r="4" fill={accent} />
      </svg>
      {settings.showDate && (
        <div className={`text-base font-rasa mt-4 ${dark ? 'text-white/50' : 'text-gray-500/70'}`}>
          {DAYS[time.getDay()]}, {MONTHS[time.getMonth()]} {time.getDate()}
        </div>
      )}
    </div>
  );
}
